import { createFileRoute } from '@tanstack/react-router';

import { PortalUpgradePage } from '@/modules/portal/pages/PortalUpgradePage';

export const Route = createFileRoute('/account/upgrade/')({
  component: PortalUpgradePage,
});
